import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import styled from 'styled-components'

const ColunaEsquerda = styled.div`
  margin-right: 32px;
  padding-top: 20px;
  width: calc(48% - 20px);

  @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
    margin: 0 auto;
    padding-top: 0px;
    width: 70%;
  }

  @media( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    width: 95%;
  }

  .card {
    position: relative;

    @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
      margin: 0 0 20px;
      padding: 20px;
    }
  }
`

export default ColunaEsquerda
